"use strict";

import {
  default as React,
  Component,
} from 'react';

import PropTypes from 'prop-types';

import {
  XAxis,
  YAxis,
  XGrid,
  YGrid,
  Legend
} from 'kaidoo-chart/core';

import {
  BarGroup,
  Chart
} from 'kaidoo-chart/shape';

import CommonProps from './commonProps';

export default class BarGroupChart extends Component {

  constructor(props) {
    super(props);
  }

  static defaultProps = {
    onMouseOver: () => {},
    onMouseOut: () => {},
    ...CommonProps
  }

  static propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    margins: PropTypes.object.isRequired,
    data: PropTypes.array.isRequired,
    chartSeries: PropTypes.array.isRequired
  }

  render() {

    const {
      width,
      height,
      margins,
      data,
      chartSeries,
      showXGrid,
      showYGrid,
      showLegend,
      categoricalColors
    } = this.props;

    let xgrid, ygrid;

    if(showXGrid) xgrid = <XGrid/>
    if(showYGrid) ygrid = <YGrid/>

    return (
      <div>
        {showLegend?
          <Legend
            {...this.props}
            width= {width}
            margins= {margins}
            chartSeries= {chartSeries}
            categoricalColors= {categoricalColors}
          />
          : null
        }
        <Chart
          {...this.props}
          width= {width}
          height= {height}
          data= {data}
          chartSeries= {chartSeries}
          >
          <BarGroup
            chartSeries= {chartSeries}
          />
          {xgrid}
          {ygrid}
          <XAxis/>
          <YAxis/>
          {this.props.children}
        </Chart>
      </div>
    )
  }
}
